import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Loader2, Box } from "lucide-react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import { http } from "../../axios/axios";
import SectionHeader from "../SectionHeader";
import ProductCard from "../ProductCard";

const CameraCategoryBar = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLatest = async () => {
      try {
        setLoading(true);

        const res = await http.get("/products/latest", {
          params: {
            limit: 40,
          },
        });

        setProducts(res.data?.products || []);
      } catch (err) {
        console.error(
          "Latest Products Fetch Error:",
          err.response?.data || err.message
        );

        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLatest();
  }, []);

  if (loading) {
    return (
      <div className="py-20 flex flex-col items-center justify-center bg-white">
        <Loader2
          className="animate-spin text-blue-600 mb-2"
          size={30}
        />

        <p className="text-[10px] font-black uppercase tracking-[0.3em] text-blue-600">
          Syncing Intelligence...
        </p>
      </div>
    );
  }

  return (
    <section className="px-4 sm:px-6 lg:px-8 py-12">
      <SectionHeader
        badge="Verified Hardware"
        title="Latest Arrivals"
        description="Explore the newest security surveillance and IT products added to our catalogue."
        showLine={true}
        action={
          <Link
            to="/security-product"
            className="
              group
              inline-flex
              items-center
              gap-2
              text-sm
              font-semibold
              text-slate-700
              hover:text-blue-600
              transition-colors
            "
          >
            View All Products

            <ArrowRight
              size={16}
              className="group-hover:translate-x-1 transition-transform"
            />
          </Link>
        }
      />

      {products.length > 0 ? (
        <Swiper
          modules={[Autoplay, Pagination]}
          slidesPerView={1}
          slidesPerGroup={1}
          spaceBetween={12}
          speed={600}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          pagination={{
            clickable: true,
          }}
          loop={products.length > 8}
          breakpoints={{
            640: { slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 16 },
            768: { slidesPerView: 3, slidesPerGroup: 1, spaceBetween: 18 },
            1024: { slidesPerView: 4, slidesPerGroup: 1, spaceBetween: 20 },
          }}
          className="pb-12"
        >
          {products.map((item) => (
            <SwiperSlide key={item._id} className="h-auto">
              <ProductCard item={item} />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div
          className="
            py-20
            text-center
            border
            border-dashed
            border-slate-300
            rounded-2xl
            bg-slate-50
          "
        >
          <Box
            size={40}
            className="mx-auto text-slate-300 mb-4"
          />

          <h3 className="text-lg font-semibold text-slate-700 mb-2">
            No Products Available
          </h3>

          <p className="text-sm text-slate-500">
            We are currently updating our product collection.
            Please check back soon.
          </p>
        </div>
      )}
    </section>
  );
};

export default CameraCategoryBar;